module.exports = __webpack_public_path__ + "static/media/alti.d5a4e4a2.svg";